import React from "react";

const st0 = { fill: "none" };
const st1 = { fill: "none", stroke: "#000000" };

const CalculatorBlkSVG = ({ style }) => {
  return (
    <svg
      x
      mlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 16 19"
      style={{ enableBackground: "new 0 0 16 19", ...style }}
    >
      <g id="Raggruppa_1293" transform="translate(-1704 -101)">
        <g id="Rettangolo_603" transform="translate(1704 101)">
          <rect y="0" className="calc_st0" style={st0} width="16" height="19" />
          <rect
            x="0.5"
            y="0.5"
            className="calc_st1"
            style={st1}
            width="15"
            height="18"
          />
        </g>
        <rect id="Rettangolo_604" x="1707" y="104" width="10" height="4" />
        <rect id="Rettangolo_605" x="1707" y="110" width="2" height="1" />
        <rect id="Rettangolo_607" x="1711" y="110" width="2" height="1" />
        <rect id="Rettangolo_608" x="1715" y="110" width="2" height="1" />
        <rect id="Rettangolo_609" x="1707" y="112" width="2" height="1" />
        <rect id="Rettangolo_610" x="1711" y="112" width="2" height="1" />
        <rect id="Rettangolo_611" x="1715" y="112" width="2" height="1" />
        <rect id="Rettangolo_612" x="1707" y="114" width="2" height="1" />
        <rect id="Rettangolo_613" x="1711" y="114" width="2" height="1" />
        <rect id="Rettangolo_614" x="1715" y="114" width="2" height="1" />
        <rect id="Rettangolo_615" x="1707" y="116" width="2" height="1" />
        <rect id="Rettangolo_616" x="1711" y="116" width="2" height="1" />
        <rect id="Rettangolo_617" x="1715" y="116" width="2" height="1" />
      </g>
    </svg>
  );
};

const CalculatorWhtSVG = ({ style }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="19"
      viewBox="0 0 16 19"
      style={style}
    >
      <g
        id="Raggruppa_1293"
        data-name="Raggruppa 1293"
        transform="translate(-1704 -101)"
      >
        <g
          id="Rettangolo_603"
          data-name="Rettangolo 603"
          transform="translate(1704 101)"
          fill="none"
          stroke="#fff"
          stroke-width="1"
        >
          <rect width="16" height="19" stroke="none" />
          <rect x="0.5" y="0.5" width="15" height="18" fill="none" />
        </g>
        <rect
          id="Rettangolo_604"
          data-name="Rettangolo 604"
          width="10"
          height="4"
          transform="translate(1707 104)"
          fill="#fff"
        />
        <rect
          id="Rettangolo_605"
          data-name="Rettangolo 605"
          width="2"
          height="1"
          transform="translate(1707 110)"
          fill="#fff"
        />
        <rect
          id="Rettangolo_607"
          data-name="Rettangolo 607"
          width="2"
          height="1"
          transform="translate(1711 110)"
          fill="#fff"
        />
        <rect
          id="Rettangolo_608"
          data-name="Rettangolo 608"
          width="2"
          height="1"
          transform="translate(1715 110)"
          fill="#fff"
        />
        <rect
          id="Rettangolo_609"
          data-name="Rettangolo 609"
          width="2"
          height="1"
          transform="translate(1707 112)"
          fill="#fff"
        />
        <rect
          id="Rettangolo_610"
          data-name="Rettangolo 610"
          width="2"
          height="1"
          transform="translate(1711 112)"
          fill="#fff"
        />
        <rect
          id="Rettangolo_611"
          data-name="Rettangolo 611"
          width="2"
          height="1"
          transform="translate(1715 112)"
          fill="#fff"
        />
        <rect
          id="Rettangolo_612"
          data-name="Rettangolo 612"
          width="2"
          height="1"
          transform="translate(1707 114)"
          fill="#fff"
        />
        <rect
          id="Rettangolo_613"
          data-name="Rettangolo 613"
          width="2"
          height="1"
          transform="translate(1711 114)"
          fill="#fff"
        />
        <rect
          id="Rettangolo_614"
          data-name="Rettangolo 614"
          width="2"
          height="1"
          transform="translate(1715 114)"
          fill="#fff"
        />
        <rect
          id="Rettangolo_615"
          data-name="Rettangolo 615"
          width="2"
          height="1"
          transform="translate(1707 116)"
          fill="#fff"
        />
        <rect
          id="Rettangolo_616"
          data-name="Rettangolo 616"
          width="2"
          height="1"
          transform="translate(1711 116)"
          fill="#fff"
        />
        <rect
          id="Rettangolo_617"
          data-name="Rettangolo 617"
          width="2"
          height="1"
          transform="translate(1715 116)"
          fill="#fff"
        />
      </g>
    </svg>
  );
};

export { CalculatorBlkSVG, CalculatorWhtSVG };
